// @flow

import sharedDialogStyles from '../../Styles/SharedDialogStyles';

const addStaffDialogStyles = {
  // Import shared styles
  ...sharedDialogStyles,
  
  // Component-specific styles
  selectLabel: (theme) => ({
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),  // Standard 16px spacing
    marginBottom: theme.spacing(0.5)
  }),
  
  formControlSelect: (theme) => ({
    ...sharedDialogStyles.formControlStandard(theme),
    width: `calc(100% - ${theme.spacing(2)})`,
    marginTop: 0  // Remove margin since label is separate
  }),
  
  channelFormControlCtr: (theme) => ({
    marginTop: theme.spacing(0.5)  // Small gap after label
  })
};

export default addStaffDialogStyles;
